import { useRef } from "react";
import { motion, useInView } from "framer-motion";

function Digit({ value, delay }) {
  return (
    <span className="relative inline-flex overflow-hidden" style={{ height: "1em", lineHeight: 1 }}>
      <motion.span className="flex flex-col" initial={{ y: 0 }} animate={{ y: `-${value}em` }}
        transition={{ type: "spring", stiffness: 70, damping: 16, delay }}>
        {Array.from({ length: 10 }).map((_, n) => (
          <span key={n} style={{ height: "1em", lineHeight: 1 }} className="flex items-center justify-center">{n}</span>
        ))}
      </motion.span>
    </span>
  );
}

// Odometer-style rolling number counter.
export function Odometer({ value, suffix = "", className = "" }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-80px" });
  const digits = String(value).split("");
  return (
    <span ref={ref} className={`inline-flex items-end tabular-nums ${className}`}>
      {digits.map((d, i) =>
        d >= "0" && d <= "9"
          ? <Digit key={i} value={inView ? Number(d) : 0} delay={i * 0.08} />
          : <span key={i}>{d}</span>
      )}
      {suffix}
    </span>
  );
}
